import { FormItem } from '../../../../../../commons/Form/Form.types';
import { CreateProspectDIRFormSchema } from './CreateProspectDIRForm.types';

export const createProspectStepData: FormItem<CreateProspectDIRFormSchema>[][] = [
  [
    {
      name: 'name_company',
      placeholder: "Nom de l'entreprise...",
      label: "Nom de l'entreprise",
      type: 'text',
      required: true,
    },
    {
      name: 'name',
      placeholder: 'Nom du prospect...',
      label: 'Nom',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'email',
      placeholder: 'Adresse email du prospect...',
      label: 'Adresse email',
      type: 'text',
      required: true,
    },
    {
      name: 'phone',
      placeholder: 'Numéro de téléphone du prospect...',
      label: 'Téléphone',
      type: 'tel',
      required: true,
    },
  ],
  [
    {
      name: 'commercialId',
      placeholder: 'Selectionner un commercial...',
      label: 'Commercial',
      type: 'select',
      id: 'commercial-ids'
    },
  ],
];
